module.exports = __webpack_public_path__ + "static/img/200226.fce18d61.png";